import { createElement, type ReactNode } from 'react'
import type { TMessageDoc } from '@modules/types'

const NODE_TAGS: Partial<Record<string, string>> = {
  paragraph: 'p',
  bulletList: 'ul',
  orderedList: 'ol',
  listItem: 'li',
  tableRow: 'tr',
  tableHeader: 'th',
  tableCell: 'td',
}

const MARK_TAGS: Partial<Record<string, string>> = {
  bold: 'strong',
  italic: 'em',
}

const renderNode = (node: TMessageDoc, key: number): ReactNode => {
  if (node.type === 'text') {
    return (node.marks ?? []).reduce<ReactNode>((text, mark) => {
      const tag = MARK_TAGS[mark.type]
      return tag ? createElement(tag, { key }, text) : text
    }, node.text)
  }
  if (node.type === 'hardBreak') return <br key={key} />
  const children = (node.content ?? []).map(renderNode)
  if (node.type === 'table')
    return (
      <table key={key}>
        <tbody>{children}</tbody>
      </table>
    )
  const tag = NODE_TAGS[node.type ?? '']
  return tag ? createElement(tag, { key }, children) : null
}

export const MessageDocument = ({ doc }: { doc: TMessageDoc }) => (
  <>{(doc.content ?? []).map(renderNode)}</>
)
